/* stylelint-disable */
:host {
  display: block;
}

:host(:not([dir="rtl"])) {
  text-align: left;
}

:host([dir="rtl"]) {
  text-align: right;
}

.related-product-card {
  position: relative;
}

@media screen and (min-width: 980px) {
  .related-product-card {
    display: flex;
  }
}

.related-product-card__link {
  display: flex;
  text-decoration: none;
  font-weight: normal;
  min-height: 100px;
}

@media screen and (min-width: 980px) {
  .related-product-card__link {
    flex: 1;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
  }
}

.related-product-card__controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 979px) {
  .related-product-card__controls {
    padding-top: 12px;
  }
}

@media screen and (min-width: 980px) {
  .related-product-card__controls {
    min-width: 215px;
  }

  :host(:not([dir="rtl"])) .related-product-card__controls {
    margin-left: 10px;
  }

  :host([dir="rtl"]) .related-product-card__controls {
    margin-right: 10px;
  }
}

.related-product-card__img {
  object-fit: contain;
}

@media screen and (max-width: 979px) {
  .related-product-card__img {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
  }

  :host(:not([dir="rtl"])) .related-product-card__img {
    margin-right: 10px;
  }

  :host([dir="rtl"]) .related-product-card__img {
    margin-left: 10px;
  }
}

@media screen and (min-width: 980px) {
  .related-product-card__img {
    width: 100px;
    height: 100px;
  }

  :host(:not([dir="rtl"])) .related-product-card__img {
    margin-right: 20px;
  }

  :host([dir="rtl"]) .related-product-card__img {
    margin-left: 20px;
  }
}

.related-product-card__title {
  font-weight: bold;
  color: #333333;
}

@media screen and (max-width: 979px) {
  .related-product-card__title {
    font-size: 14px;
    line-height: 1.4285714286;
  }
}

@media screen and (min-width: 980px) {
  .related-product-card__title {
    font-size: 14px;
    line-height: 1.7142857143;
    padding-top: 16px;
  }
}

.related-product-card__link:hover .related-product-card__title {
  text-decoration: underline;
}

.related-product-card__description {
  color: #333333;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.3333333333;
}

.related-product-card__price {
  font-weight: normal;
}

@media screen and (max-width: 979px) {
  .related-product-card__price {
    order: -1;
    font-size: 16px;
    padding-bottom: 10px;
  }
}

@media screen and (min-width: 980px) {
  .related-product-card__price {
    text-align: center;
    font-size: 14px;
    padding-top: 12px;
  }
}

.related-product-card__price-value {
  font-weight: bold;
}

@media screen and (min-width: 980px) {
  .related-product-card__price-value {
    font-size: 18px;
  }
}

.related-product-card__button {
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-standard-text);
  --qds-control-hero-gap-internal: var(--qds-control-standard-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-standard-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-standard-padding-horizontal);
  display: block;
  width: 100%;
}

.related-product-card__button + .related-product-card__button {
  margin-top: 10px;
}

.related-product-card__quantity {
  margin: 0px 50px;
  display: flex;
  text-decoration: none;
  font-weight: normal;
  min-height: 100px;
}

@media screen and (min-width: 980px) {
  .related-product-card__quantity {
    flex: 1;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
  }
}

.related-product-card__quantity .related-product-card__description {
  text-align: center;
}